import { render } from "./GlobalAiAssistant.vue?vue&type=template&id=044aa274"
import script from "./GlobalAiAssistant.vue?vue&type=script&lang=js"
export * from "./GlobalAiAssistant.vue?vue&type=script&lang=js"

import "./GlobalAiAssistant.vue?vue&type=style&index=0&id=044aa274&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__